import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from './ui/Modal';

interface SignupModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SignupModal: React.FC<SignupModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    onClose();
    navigate('/contact');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="sm:flex sm:items-start">
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 className="text-xl font-semibold leading-6 text-gray-900">
            Want to compare more mortgages?
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              We're working on support for comparing more than three mortgages at a time.
              If you'd like to be notified when this feature launches, send us a message
              through our contact page and let us know you're interested.
            </p>
          </div>
          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <button
              type="button"
              onClick={handleContactClick}
              className="inline-flex w-full justify-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              Go to Contact Page
            </button>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};